import React from 'react'

const Badge = ({ children }) => {
  return (
    <span className="card-vehicle__label-featured">{ children }</span>
  )
}

export default Badge
